import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles<Theme>((theme) => ({
  buttonContainer: {
    marginTop: theme.spacing(4),
  },
}));

export default useStyles;
